// removed by extract-text-webpack-plugin
module.exports = {"contactSection":"qrR0SbtMagIKaOAq2EHDR","contactTitle":"_2NCGwY4929iHXLLUCFlsU8","contactInfo":"_62s_hClxf5IeukYnJEMvI","title":"_1fazPcMW4bQ1Qw1_A1-Dj5","placeholder":"_2f1sRXPf3mKoeqftF9wn6-","img":"m7G8Wwv7V4lZni3s4zEUT"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/contact/Contact.css
// module id = 398
// module chunks = 0